window.Products.Accessory.PencilCase = function () {
};
window.Products.Accessory.PencilCase.inherits(window.Products.Accessory.Accessory);

window.Products.Accessory.PencilCase.id = 7;
window.Products.Accessory.PencilCase.slug = 'pencil-case';
window.Products.Accessory.PencilCase.has_3d = true;
window.Products.Accessory.PencilCase.dpi = 150;

window.Products.Accessory.PencilCase.prototype.set3dProperties = function (modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = -0.24;
};

window.Products.Accessory.PencilCase.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[1].material.map = modelViewer.texture;
};

window.Products.Accessory.PencilCase.prototype.setThreeControls = function (controls) {
    controls.minDistance = 2.3;
    controls.maxDistance = 4.2;
};